module.exports = __webpack_public_path__ + "static/media/12.e56bc41a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/12.svg
// module id = 139
// module chunks = 0